<template>
    <Popup :open="open" @close="closePopup" @open="togglePopup" :padding="true">
        <Loading :loading="loading" preserveHeight="true">
            <div>
                <p>
                    {{ $t('Choose the Payment Method for') }}:
                    <br />
                    <span class="font-bold">{{ $translate(abonnement.product.name) }}</span>
                </p>
                <div v-if="getPaymentMethods?.data?.length">
                    <div class="grid grid-cols-1 gap-4 my-6">
                        <SinglePaymentMethod
                            v-for="paymentMethod in getPaymentMethods.data"
                            :key="paymentMethod.id"
                            :showToggle="true"
                            :active="selectedPaymentMethod === paymentMethod.id"
                            :paymentMethod="paymentMethod"
                            @click="selectedPaymentMethod = paymentMethod.id"
                        >
                        </SinglePaymentMethod>
                    </div>
                </div>
                <div class="flex flex-wrap flex-row gap-4 mt-4">
                    <FormButton type="button" class="w-auto" styling="primary xs flex items-center gap-3 text-xs" @click="closePopup" :value="$t('plain_abort')"> </FormButton>
                    <FormButton
                        type="button"
                        class="w-auto"
                        styling="secondary xs flex items-center gap-3 text-xs"
                        @click="process(abonnement)"
                        :value="$t('plain_next')"
                        :disabled="!selectedPaymentMethod"
                    >
                    </FormButton>
                </div>
            </div>
        </Loading>
    </Popup>
</template>
<script>
import { mapGetters } from 'vuex';
import i18next from 'i18next';
import api from '../../api';

export default {
    props: ['open', 'abonnement'],
    emits: ['update:open', 'reload'],
    data() {
        return {
            selectedPaymentMethod: null,
            loading: false
        };
    },
    computed: {
        ...mapGetters('payment_methods', {
            getPaymentMethods: 'get'
        })
    },
    watch: {
        open: function (newVal) {
            if (!newVal) {
                this.resetState();
            }
        }
    },
    mounted() {
        this.loadPaymentMethods();
    },
    methods: {
        loadPaymentMethods() {
            this.loading = true;
            this.$store.dispatch('payment_methods/index').then(() => {
                this.loading = false;
                this.selectedPaymentMethod = this.abonnement.userPaymentMethod.id;
            });
        },
        process() {
            api.put(`/api/v1/abonnements/${this.abonnement.id}/set-user-payment-method/${this.selectedPaymentMethod}`)
                .then((response) => {
                    this.$emit('update:open', false);
                    this.$emit('reload');
                    this.$toast.success(i18next.t('msg_payment_method_succesfully_radded'));
                })
                .catch((error) => {
                    this.$toast.error(i18next.t('msg_payment_method_error_updating'));
                });
        },
        closePopup() {
            this.$emit('update:open', false);
        },
        togglePopup() {
            this.$emit('update:open', !this.open);
        },
        resetState() {
            this.selectedPaymentMethod = null;
            this.loading = false;
        }
    }
};
</script>
